module.exports = __webpack_public_path__ + "img/hong11.1015854c.png";